module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/chapel-suns_spot_02-0297fff963d0ceda416561262294b5cf.jpg";